import { ConcreteEncodable } from "./ConcreteEncodable";

import { LinkedRelationshipImplEncoder } from "../../encoder/LinkedRelationshipImplEncoder";

import * as CubiqTS from "../../index";
import { LinkedRelationship } from "../LinkedRelationship";
import { v4 as uuid } from "uuid";

export class LinkedRelationshipImpl extends ConcreteEncodable implements LinkedRelationship {
  public static enType: string = "com.bcdfx.model.event.lifecycle.LinkedRelationshipImpl";

  /*FID=2*/
  public parentId: string;
  /*FID=3*/
  public relationshipType: CubiqTS.OrderRelationshipType;
  /*FID=4*/
  public siblingId: string;
  /*FID=5*/
  public order: CubiqTS.OrderRequestDataImpl;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = LinkedRelationshipImplEncoder.Instance;
    this.setEncodableType(LinkedRelationshipImpl.enType);
    this.messageId = uuid();
  }

  public toString(): string {
    return (
      "LinkedRelationshipImpl[" +
      "parentId=" +
      this.parentId +
      "relationshipType=" +
      this.relationshipType +
      "siblingId=" +
      this.siblingId +
      "order=" +
      this.order +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
